import React, { useRef, useState } from "react";
import SimpleExperienceCard from "../base/card/simpleExperienceCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import "swiper/css/navigation";

const ProgramExperiences = ({
  experiences,
  expHeading,
  expSubHeading,
  expTabSubtitle,
  expBgColor
}) => {
  const swiperRef = useRef(null);
  const [swiper, setSwiper] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <>
      {experiences && experiences.length > 0 && (
        <section className="relative flex items-center justify-center w-full mx-auto">
          <section className="flex flex-wrap justify-center w-11/12 gap-10 pb-12 sm:flex-nowrap sm:w-10/12">
            <div className="w-full mr-auto md:sticky-left-section">
              <section className="flex items-center justify-center">
                <div className="container z-20 w-full pt-12 pr-0 sm:pr-10">
                  <div className="gvi-experiences text-left">
                    <div
                      className="heading font-lato text-black-lighter dark:text-white pb-2 font-light text-3xl leading-8 sm:leading-[38px]"
                      dangerouslySetInnerHTML={{ __html: expHeading }}
                    />
                    <h3
                      className="!font-light"
                      dangerouslySetInnerHTML={{ __html: expSubHeading }}
                    />
                  </div>
                  <div className="sub-heading text-xs text-black-lighter dark:text-gray-generic mt-7 pl-2 border-l-[2px] border-l-red-light dark:border-l-green-standard">
                    {expTabSubtitle}
                  </div>

                  <section className="py-12 md:py-8">
                    <div className="hidden md:grid grid-cols-2 md:grid-cols-4 gap-x-2 gap-y-4">
                      {experiences &&
                        experiences.length > 0 &&
                        experiences?.map((experience, idx) => {
                          const experienceTitle = experience.experienceTitle;
                          const experienceFeaturedImage =
                            experience?.experienceFeaturedImage;
                          const experienceFeaturedImageFallback =
                            experience.experienceFeaturedImage?.sourceUrl;

                          return (
                            <div
                              className="flex flex-col h-full rounded-md"
                              key={idx}
                            >
                              <SimpleExperienceCard
                                experienceTitle={experienceTitle}
                                experienceFeaturedImage={
                                  experienceFeaturedImage
                                }
                                fallbackImage={experienceFeaturedImageFallback}
                                slim={true}
                                titleBgCol={expBgColor}
                              />
                            </div>
                          );
                        })}
                    </div>
                    <div className="md:hidden md:pt-2">
                      <Swiper
                        ref={swiperRef}
                        speed={1300}
                        onSwiper={setSwiper}
                        grabCursor={true}
                        spaceBetween={0}
                        loop={true}
                        className="z-20"
                        slidesPerView={1.25}
                        onSlideChange={(swiperCore) => {
                          const { activeIndex } = swiperCore;
                          setCurrentSlide(activeIndex);
                        }}
                        breakpoints={{
                          480: {
                            slidesPerView: 1.25,
                            spaceBetween: 15
                          },
                          640: {
                            slidesPerView: 3,
                            spaceBetween: 15
                          },
                          1024: {
                            slidesPerView: 6,
                            spaceBetween: 15
                          }
                        }}
                      >
                        {experiences &&
                          experiences.length > 0 &&
                          experiences?.map((experience, idx) => (
                            <SwiperSlide key={idx}>
                              <SimpleExperienceCard
                                experienceTitle={experience.experienceTitle}
                                experienceFeaturedImage={
                                  experience?.experienceFeaturedImage
                                }
                                fallbackImage={
                                  experience.experienceFeaturedImage?.sourceUrl
                                }
                                slim={true}
                                titleBgCol={expBgColor}
                                outerContainerClass={"relative px-4 md:px-0"}
                              />
                            </SwiperSlide>
                          ))}
                      </Swiper>

                      <div
                        className="swiper-button-prev !-left-16 !w-11 h-11 after:hidden !hidden md:!block"
                        onClick={() => {
                          swiper.slidePrev();
                        }}
                      />

                      <div
                        className="swiper-button-next rotate-180 !-right-16 !w-11 h-11 after:hidden !hidden md:!block"
                        onClick={() => {
                          swiper.slideNext();
                        }}
                      />
                    </div>
                  </section>
                </div>
              </section>
            </div>
          </section>
        </section>
      )}
    </>
  );
};

export default ProgramExperiences;
